import React, { Component } from 'react'

export default class myRead extends Component {
    render() {
        return (
            <div className="list-books-title">
            <h1>MyReads</h1>
          </div>
        )
    }
}
